import { BaseComponent } from '../../base-component';
import { VideoPlayerEvent } from '../../video/client/video-player';
import { initVideoPlayer } from '../../_common/client/nexus-interfaces/video';
import { isMobile } from '../../_common/client/breakpoint';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class VideoInPageComponent extends BaseComponent {
    public rootSelector = '.js_pdp_video-in-page';
    public assetKey: string | undefined;
    private playerTargetElementId = 'inPageVideoPlayerArea';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const rootElement = this.getRootElement();
        this.assetKey = rootElement.dataset.assetKey;

        if (this.assetKey === undefined) {
            this.logger?.logError({ type: 'OnHtmlLoadedError', message: 'assetKey is undefined, cannot create player.' });
            return;
        }

        try {
            const aspectRatio = this.determineAspectRatio(rootElement);
            await this.createPlayer(this.assetKey, aspectRatio);
        } catch (error: unknown) {
            this.logger?.logError({
                type: 'OnHtmlLoadedError',
                message: `Es ist ein technischer Fehler aufgetreten. Video konnte nicht geladen werden. (asset ${this.assetKey}).`,
                error: error as Error,
            });
            trackEvent({ product_VideoInpage: [(error as Error)?.message] });
        }
    }

    private determineAspectRatio(rootElement: HTMLElement): string {
        return isMobile() && rootElement.dataset.assetRatio === 'portrait' ? '9:16' : '16:9';
    }

    private async createPlayer(assetKey: string, aspectRatio: string): Promise<void> {
        await initVideoPlayer({
            assetKey,
            parentId: this.playerTargetElementId,
            backgroundColor: '#000000',
            stage: {
                aspectRatio,
                width: '100%',
            },
            autoplay: false,
            onProgress10: playerState => this.trackPlayerEvent(playerState, 'progress_0.1'),
            onProgress50: playerState => this.trackPlayerEvent(playerState, 'progress_0.5'),
            onProgress90: playerState => this.trackPlayerEvent(playerState, 'progress_0.9'),
            onQualityChange: playerState => this.trackPlayerEvent(playerState, 'changeQuality'),
            onInitialVideoStart: playerState => this.trackPlayerEvent(playerState, 'start'),
            onFullscreenChange: playerState =>
                this.trackPlayerEvent(playerState, playerState.isFullscreen ? 'openFullscreen' : 'closeFullscreen'),
            onChangeVideo: playerState => this.trackPlayerEvent(playerState, 'changeVideo'),
        });
    }

    private trackPlayerEvent(playerState: VideoPlayerEvent, trackingEventName: string): void {
        trackEvent({
            product_VideoInpage: [trackingEventName],
            product_VideoCount: [String(playerState.videoCount)],
            product_VideoLength: [String(playerState.videoLength)],
            product_VideoPosition: [String(playerState.videoPosition)],
            product_VideoQuality: [String(playerState.videoQuality)],
        });
    }
}
